import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  /**
   * Signal to track if the sidebar is minimized (sidebar-mini mode)
   */
  public isSidebarMini = signal(false);

  /**
   * Toggles the sidebar-mini state
   */
  public toggleSidebarMini() {
    this.isSidebarMini.update(val => !val);
  }

  /**
   * Explicitly sets the sidebar-mini state
   */
  public setSidebarMini(value: boolean) {
    this.isSidebarMini.set(value);
  }
}
